import { LimitOffsetPaging } from '../paged-results/limit-offset-paging.model';

export class EncounterTypeEligibilityFilters {
  clientIds = [];
  clientEntityTypes = [];
  assignedClientLeadUserIds = [];
  eligibilityStatuses = [];
  encounterType = '';
}

export class EncounterTypeEligibilityUiOptions {
  explainerExpanded = true;
}

export class EncounterTypeEligibilityListSettings {
  uiOptions: EncounterTypeEligibilityUiOptions = new EncounterTypeEligibilityUiOptions();
  filters: EncounterTypeEligibilityFilters = new EncounterTypeEligibilityFilters();
  paging: LimitOffsetPaging = LimitOffsetPaging.empty;
}
